import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "promotion"
}
const _hoisted_2 = {
  key: 0,
  class: "promotion__loader"
}
const _hoisted_3 = { class: "promotion__loader--card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "72",
  rx: "0",
  ry: "0",
  width: "450",
  height: "31"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "113",
  rx: "0",
  ry: "0",
  width: "252",
  height: "31"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "165",
  rx: "0",
  ry: "0",
  width: "252",
  height: "14"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "29",
  rx: "16",
  ry: "16",
  width: "78",
  height: "24"
}, null, -1)
const _hoisted_8 = { class: "promotion__loader--card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "72",
  rx: "0",
  ry: "0",
  width: "450",
  height: "31"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "113",
  rx: "0",
  ry: "0",
  width: "252",
  height: "31"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "165",
  rx: "0",
  ry: "0",
  width: "252",
  height: "14"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "29",
  rx: "16",
  ry: "16",
  width: "78",
  height: "24"
}, null, -1)
const _hoisted_13 = { class: "promotion__loader--card" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "72",
  rx: "0",
  ry: "0",
  width: "450",
  height: "31"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "113",
  rx: "0",
  ry: "0",
  width: "252",
  height: "31"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "165",
  rx: "0",
  ry: "0",
  width: "252",
  height: "14"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "29",
  rx: "16",
  ry: "16",
  width: "78",
  height: "24"
}, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "promotion__swiper--wrapper"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "promotion__card--text card--text" }
const _hoisted_21 = { class: "card--text__badge" }
const _hoisted_22 = { class: "card--text__title" }
const _hoisted_23 = { class: "card--text__subtitle" }
const _hoisted_24 = ["onLoad", "src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "72",
  rx: "0",
  ry: "0",
  width: "450",
  height: "31"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "113",
  rx: "0",
  ry: "0",
  width: "252",
  height: "31"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "165",
  rx: "0",
  ry: "0",
  width: "252",
  height: "14"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("rect", {
  x: "40",
  y: "29",
  rx: "16",
  ry: "16",
  width: "78",
  height: "24"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev promotion-button-prev" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next promotion-button-next" }, null, -1)

import store from '@/store'
import { computed, watch, ref, onUpdated } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Mousewheel, Lazy } from 'swiper'
import { ContentLoader } from 'vue-content-loader'

import 'swiper/css'
import 'swiper/css/navigation'

// const isCardBusy = ref(false)

export default /*#__PURE__*/_defineComponent({
  __name: 'Promotion',
  emits: ['promotion-click-card', 'promotion-cards-length'],
  setup(__props, { emit }) {

const swiperRef = ref(null)



const isCardBusy = computed(() => store.getters.isCardBusy)
const promotedCards = computed(() => {
  let data = store.getters.getCardSortItems
  if (data !== undefined && data.promoted !== undefined) {
    return data.promoted
  }

  return []
})
// watch(cardBusy, (value) => {
//   if (value) {
//     isCardBusy.value = true
//     setTimeout(() => {
//       isCardBusy.value = false
//     }, 500)
//   }
// })
onUpdated(() => {
  emit('promotion-cards-length', promotedCards.value.length)
})

const setCard = (item) => {
  // Устанавливаем карточку
  store
    .dispatch('getCardItem', { filter: { cardId: item.getCardId() } })
    .then(() => {
      // Показываем модальное окно
      emit('promotion-click-card')
    })
}

const imgLoaded = (el, id) => {
  if (el) {
    let card: any = document.querySelectorAll(`.promotion__card-${id}`)
    card.forEach((card) => {
      card.style.display = 'block'
    })
    // el.path[1].style.display = 'block'
    let loader = document.querySelectorAll(`.promotion__loader--card-${id}`)
    loader.forEach((el) => (el.style.display = 'none'))

    // el.path[1].style.display = 'block'
  }
}
const allImgLoaded = () => {
  console.log('ALL IMAGES LOADED')
  let card = document.querySelectorAll('.promotion__card')
  card.forEach((el) => {
    if (el.style.display != 'block') el.style.display = 'block'
  })
  let loader = document.querySelectorAll(`.promotion__loader--card`)
  loader.forEach((el) => {
    if (el.style.display != 'none') el.style.display = 'none'
  })
}

const beforeSwiper = (swiper) => {
  swiperRef.value = swiper
  if (swiper.device.ios) {
    swiper.params.cssMode = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(isCardBusy) || _unref(promotedCards)?.length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_unref(isCardBusy))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 780 335",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 780 335",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 780 335",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(isCardBusy) && _unref(promotedCards)?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_unref(Swiper), {
                onImagesReady: allImgLoaded,
                onBeforeInit: beforeSwiper,
                "preload-images": false,
                threshold: 5,
                class: "mySwiper",
                mousewheel: {
          forceToAxis: true,
        },
                "slides-per-view": 'auto',
                modules: [_unref(Navigation), _unref(Mousewheel)],
                navigation: {
          nextEl: '.promotion-button-next',
          prevEl: '.promotion-button-prev',
        }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(promotedCards), (promotedCardItem, idx) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: promotedCardItem }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                          onClick: ($event: any) => (setCard(promotedCardItem)),
                          class: _normalizeClass(["promotion__card", 'promotion__card-' + idx])
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(promotedCardItem.getTypeName()), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(promotedCardItem.getCardName()), 1),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(promotedCardItem.getCardInfo()), 1)
                          ]),
                          _createElementVNode("img", {
                            onLoad: (el) => imgLoaded(el, idx),
                            src: promotedCardItem.getPromotedImg(),
                            alt: ""
                          }, null, 40, _hoisted_24)
                        ], 10, _hoisted_19), [
                          [_vShow, false]
                        ]),
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(["promotion__loader--card", 'promotion__loader--card-' + idx])
                        }, [
                          _createVNode(_unref(ContentLoader), {
                            viewBox: "0 0 780 335",
                            speed: 2,
                            primaryColor: "#f3f3f3",
                            secondaryColor: "#e2e0e0"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _hoisted_26,
                              _hoisted_27,
                              _hoisted_28
                            ]),
                            _: 1
                          })
                        ], 2), [
                          [_vShow, true]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modules", "navigation"]),
              _hoisted_29,
              _hoisted_30
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})